/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Load_ErrorInputs */



/**
* | output |
* | --- |
* | "Couldn't load this partner. Please try again." |
*
* @param {Partner_Admin_Load_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_load_error = /** @type {((inputs?: Partner_Admin_Load_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Load_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Partner konnte nicht geladen werden. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("Couldn't load this partner. Please try again.")
});